// extracted by mini-css-extract-plugin
module.exports = {"skugrid":"SkuGrid-module--skugrid--S5DZ1","title":"SkuGrid-module--title--3kNMu","grid":"SkuGrid-module--grid--3lCPC"};